var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Cookies from "js-cookie";
import * as moment from "moment";
import * as React from "react";
import { apiBase } from "../../../../shared/constants";
import { getProviderUrl } from "../../utils/providerLinkBuilder";
var AvailabilityFetcher = /** @class */ (function (_super) {
    __extends(AvailabilityFetcher, _super);
    function AvailabilityFetcher() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dates: {
                endDate: null,
                startDate: null,
            },
            focusedInput: null,
            loading: false,
            nights: null,
            price: "",
            unavailable: false,
            url: "",
        };
        _this.checkAvailiblity = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, startDate, endDate, id, dates, response, availabilityResponse;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.state.dates, startDate = _a.startDate, endDate = _a.endDate;
                        id = this.props.lodgingId;
                        dates = {
                            fromDate: startDate.format("YYYY-MM-DD"),
                            toDate: endDate.format("YYYY-MM-DD"),
                        };
                        return [4 /*yield*/, fetch(apiBase + "lodgings/availability/" + id + "?fromDate=" + dates.fromDate + "&toDate=" + dates.toDate)];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        availabilityResponse = _b.sent();
                        return [2 /*return*/, availabilityResponse];
                }
            });
        }); };
        _this.setAvailability = function (availability) {
            _this.updateNights();
            _this.setState({
                price: "$" + availability.offerings[0].cost.amount,
                unavailable: false,
            });
        };
        _this.setAvailabilityCookie = function (dates) {
            if (dates) {
                var formatedDates = {
                    endDate: dates.endDate.format("YYYY-MM-DD"),
                    startDate: dates.startDate.format("YYYY-MM-DD"),
                };
                return Cookies.set("availability", formatedDates);
            }
            return Cookies.remove("availability");
        };
        _this.setAsUnavailable = function () {
            _this.setState({
                nights: null,
                price: null,
                unavailable: true,
            });
        };
        _this.updateNights = function () {
            var numNights = _this.getNumNights(_this.state.dates);
            _this.setState({ nights: numNights });
        };
        _this.updateUrl = function () {
            var provider = _this.props.provider;
            var startDate = _this.state.dates.startDate.format("YYYY-MM-DD");
            var endDate = _this.state.dates.endDate.format("YYYY-MM-DD");
            var providerUrl = getProviderUrl({ startDate: startDate, endDate: endDate }, provider);
            _this.setState({ url: providerUrl });
        };
        _this.resetFields = function () {
            _this.setState({
                nights: null,
                price: null,
                unavailable: false,
            });
        };
        _this.hasValidDates = function () {
            return (_this.state.dates.startDate && _this.state.dates.endDate) && !moment().isAfter(_this.state.dates.startDate);
        };
        _this.onDateChange = function (dates) {
            _this.setState({ dates: dates }, function () { return __awaiter(_this, void 0, void 0, function () {
                var availability;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.hasValidDates()) return [3 /*break*/, 2];
                            this.setAvailabilityCookie(this.state.dates);
                            this.toggleLoading();
                            return [4 /*yield*/, this.checkAvailiblity()];
                        case 1:
                            availability = _a.sent();
                            this.toggleLoading();
                            this.updateUrl();
                            if (availability.length) {
                                this.setAvailability(availability[0]);
                            }
                            else {
                                this.setAsUnavailable();
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            this.resetFields();
                            this.setAvailabilityCookie();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.onFocusChange = function (focusedInput) {
            return _this.setState({
                focusedInput: focusedInput,
            });
        };
        _this.getNumNights = function (dates) {
            return dates.endDate.diff(dates.startDate, "days") || null;
        };
        return _this;
    }
    AvailabilityFetcher.prototype.render = function () {
        var availabilityData = {
            dates: {
                endDate: this.state.dates.endDate && moment(this.state.dates.endDate),
                startDate: this.state.dates.startDate && moment(this.state.dates.startDate),
            },
            focusedInput: this.state.focusedInput,
            handleDateChange: this.onDateChange,
            handleFocusChange: this.onFocusChange,
            loading: this.state.loading,
            nights: this.state.nights,
            price: this.state.price,
            unavailable: this.state.unavailable,
            url: this.state.url || getProviderUrl({}, this.props.provider),
        };
        return this.props.render(availabilityData);
    };
    AvailabilityFetcher.prototype.componentDidMount = function () {
        var _this = this;
        var availCookie = Cookies.getJSON("availability");
        if (availCookie) {
            this.setState({
                dates: {
                    endDate: availCookie.endDate && moment(availCookie.endDate),
                    startDate: availCookie.startDate && moment(availCookie.startDate),
                },
            }, function () { return _this.onDateChange(_this.state.dates); });
        }
    };
    AvailabilityFetcher.prototype.toggleLoading = function () {
        this.setState({
            loading: !this.state.loading,
        });
    };
    return AvailabilityFetcher;
}(React.Component));
export { AvailabilityFetcher };
export default AvailabilityFetcher;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/booking/availabilityFetcher.tsx
// module id = zN4m
// module chunks = 2